export const topics = [
  {
    title: '기후변화 대응',
    image: '/static_img/skinc/topics/topic_1.png',
    description:
      '신재생에너지 기술 개발과 온실가스 감축 노력을 통해 지속가능한 에너지 전환을 추진합니다.'
  },
  {
    title: '사업장 에너지 효율성',
    image: '/static_img/skinc/topics/topic_2.png',
    description: '업무 환경과 운영 시스템의 에너지 효율을 높여 자원 사용을 최소화합니다.'
  },
  {
    title: '지역사회 상생 및 발전',
    image: '/static_img/skinc/topics/topic_3.png',
    description: '지역에 미치는 환경적·사회적 영향을 줄이고, 지속가능한 발전을 위해 협력합니다.'
  },
  {
    title: '산업안전보건 관리',
    image: '/static_img/skinc/topics/topic_4.png',
    description:
      '안전한 근무환경 조성과 철저한 위험관리로 임직원의 건강과 안전을 최우선으로 합니다.'
  }
];

export const icons = {
  download: `
    <svg width="40" height="40" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.3555 19.2009V4.44531" stroke="white" stroke-width="2.4" />
      <path d="M9.42236 13.5996L16.3557 20.5329L23.289 13.5996" stroke="white" stroke-width="2.4" />
      <path d="M26.6668 25.666H5.3335" stroke="white" stroke-width="2.4" />
    </svg>`,
  esg: `
    <svg width="40" height="40" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="6.53301" y1="17.334" x2="6.53301" y2="25.334" stroke="white" stroke-width="2.4" />
      <path d="M13.333 13.334L13.333 25.334" stroke="white" stroke-width="2.4" />
      <path d="M20 9.33398L20 25.334" stroke="white" stroke-width="2.4" />
      <path d="M26.667 5.33398L26.667 25.334" stroke="white" stroke-width="2.4" />
    </svg>`,
  policy: `
    <svg width="40" height="40" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M16.7111 22L24.2665 26.8065L26.6665 28.3333V25.4888V5.4V3H24.2665H9.0665H6.6665V5.4V25.4961V28.3333L9.0665 26.8201L16.7111 22ZM9.0665 23.9829L15.4311 19.9699L16.7169 19.1591L17.9994 19.975L24.2665 23.962V5.4H9.0665V23.9829Z"
        fill="white" />
    </svg>`,
  gri: `
    <svg width="40" height="40" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.9997 10.668L15.9997 18.668M15.9997 32.0013L15.9997 18.668M15.9997 18.668L21.333 13.3346"
        stroke="white" stroke-width="2.4" />
      <rect x="6.53301" y="1.2" width="18.9333" height="24.2667" rx="9.46667" stroke="white" stroke-width="2.4" />
    </svg>`
};

export const getBottomNavItems = lang => {
  const isEng = lang === 'ENG';
  return [
    {
      id: 'report',
      text: isEng ? 'Download Report' : '보고서 다운로드',
      url: isEng
        ? '/document/skinc/2025_SK-Inc_Sustainability Report_ENG.pdf'
        : '/document/skinc/2025_SK-Inc_Sustainability Report_KOR.pdf',
      svgIcon: icons.download
    },
    {
      id: 'esgData',
      text: 'ESG Data',
      url: getLanguageAppliedUrl('https://esg.sk-inc.com/?r=skinc&lv1=Appendix&lv2=ESG+Data', lang),
      svgIcon: icons.esg
    },
    {
      id: 'policy',
      text: 'Policy & Principle',
      url: getLanguageAppliedUrl(
        'https://esg.sk-inc.com/?r=skinc&lv1=Appendix&lv2=Policy+%26+Principle',
        lang
      ),
      svgIcon: icons.policy
    },
    {
      id: 'gri',
      text: 'GRI/SASB/TCFD',
      url: getLanguageAppliedUrl(
        'https://esg.sk-inc.com/?r=skinc&lv1=Appendix&lv2=GRI%2FSASB%2FTCFD+Index',
        lang
      ),
      svgIcon: icons.gri
    }
  ];
};

const getLanguageAppliedUrl = (baseUrl, lang) => {
  if (lang !== 'ENG') {
    return baseUrl;
  }

  if (baseUrl.startsWith('#')) {
    const url = new URL(window.location.href);
    url.searchParams.set('l', 'ENG');
    url.hash = baseUrl;
    return url.href;
  }

  try {
    const url = new URL(baseUrl);
    url.searchParams.set('l', 'ENG');
    return url.href;
  } catch (e) {
    console.error('Invalid URL:', baseUrl);
    return baseUrl;
  }
};

export const heroCards_KR = [
  {
    title: 'ESG Letter',
    desc: `<p>투명한 정보 공개를 통해 이해관계자와의 소통을 확대하고, 지속가능성 경영에 대한 인식을 높이기 위해 최선을 다하겠습니다.</p>`,
    img: '/static_img/skinc/esg_story/story_contents4.webp',
    link: 'https://esg.sk-inc.com/?r=skinc&lv1=SK+ESG+Story&lv2=ESG+Letter'
  },
  {
    title: 'SK Double Bottom Line',
    desc: `<p>사회와 더불어 성장하고자 SK그룹의 경제적 가치와 사회적 가치를 동시에 추구하는 DBL (Double Bottom Line) 경영을 실천하고 있습니다.</p>`,
    img: '/static_img/skinc/esg_story/story_contents1.webp',
    link: 'https://esg.sk-inc.com/?r=skinc&lv1=SK+ESG+Story&lv2=SK+Double+Bottom+Line'
  },
  {
    title: 'Value Creation Story',
    desc: `<p>SK그룹 차원의 기업가치를 제고하기 위해 투자 포트폴리오를 혁신하고, 종합 IT 서비스 등 다양한 솔루션을 제공하여 고객의 디지털 경쟁력 강화에 기여하고 있습니다.</p>`,
    img: '/static_img/skinc/esg_story/story_contents2.webp',
    link: 'https://esg.sk-inc.com/?r=skinc&lv1=SK+ESG+Story&lv2=Value+Creation+Story'
  },
  {
    title: 'ESG Key Metrics',
    desc: `<p>ESG 지표별 성과를 체계적으로 관리하여 지속가능경영을 추진하고 있습니다.</p>`,
    img: '/static_img/skinc/esg_story/story_contents3.webp',
    link: 'https://esg.sk-inc.com/?r=skinc&lv1=SK+ESG+Story&lv2=ESG+Key+Metrics'
  }
];

export const heroCards_ENG = [
  {
    title: 'ESG Letter',
    desc: `<p>SK Inc. is committed to expanding stakeholder engagement and enhancing awareness of sustainability management through transparent disclosure.</p>`,
    img: '/static_img/skinc/esg_story/story_contents4.webp',
    link: 'https://esg.sk-inc.com/?l=ENG&r=skinc&lv1=SK+ESG+Story&lv2=ESG+Letter'
  },
  {
    title: 'SK Double Bottom Line',
    desc: `<p>Through Double Bottom Line (DBL) management, SK Group is pursuing both economic and social values, with a focus on growth in harmony with society.</p>`,
    img: '/static_img/skinc/esg_story/story_contents1.webp',
    link: 'https://esg.sk-inc.com/?l=ENG&r=skinc&lv1=SK+ESG+Story&lv2=SK+Double+Bottom+Line'
  },
  {
    title: 'Value Creation Story',
    desc: `<p>To enhance corporate value at the SK Group level, the investment portfolio is being innovated, and a wide range of solutions, including integrated IT services, are provided to help strengthen customers' digital competitiveness.</p>`,
    img: '/static_img/skinc/esg_story/story_contents2.webp',
    link: 'https://esg.sk-inc.com/?l=ENG&r=skinc&lv1=SK+ESG+Story&lv2=Value+Creation+Story'
  },
  {
    title: 'ESG Key Metrics',
    desc: `<p>Performance across ESG metrics is systematically managed to promote sustainability management.</p>`,
    img: '/static_img/skinc/esg_story/story_contents3.webp',
    link: 'https://esg.sk-inc.com/?l=ENG&r=skinc&lv1=SK+ESG+Story&lv2=ESG+Key+Metrics'
  }
];

export const cardInfo = {
  ENG: {
    image: '',
    topics: [
      {
        name: 'Climate Change Response (Mitigation/Adaptation) ',
        link: 'https://esg.sk-inc.com/?l=ENG&r=skinc&lv1=Materiality&lv2=%EC%98%81%ED%96%A5+%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C#order_id_6'
      },
      {
        name: 'Ethical Management and Anti-Corruption',
        link: 'https://esg.sk-inc.com/?l=ENG&r=skinc&lv1=Materiality&lv2=%EC%98%81%ED%96%A5+%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C#order_id_9'
      },
      {
        name: 'Talent Development and Human Resource Management',
        link: 'https://esg.sk-inc.com/?l=ENG&r=skinc&lv1=Materiality&lv2=%EC%98%81%ED%96%A5+%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C#order_id_12'
      },
      {
        name: 'Respect for and Protection of Human Rights',
        link: 'https://esg.sk-inc.com/?l=ENG&r=skinc&lv1=Materiality&lv2=%EC%98%81%ED%96%A5+%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C#order_id_15'
      },
      {
        name: 'Safety and Health Management',
        link: 'https://esg.sk-inc.com/?l=ENG&r=skinc&lv1=Materiality&lv2=%EC%98%81%ED%96%A5+%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C#order_id_18'
      }
    ]
  },
  KOR: {
    image: '',
    topics: [
      {
        name: '기후변화 대응 (완화/적응)',
        link: 'https://esg.sk-inc.com/?r=skinc&lv1=Materiality&lv2=%EC%98%81%ED%96%A5+%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C#order_id_6'
      },
      {
        name: '윤리경영 및 반부패',
        link: 'https://esg.sk-inc.com/?r=skinc&lv1=Materiality&lv2=%EC%98%81%ED%96%A5+%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C#order_id_9'
      },
      {
        name: '인재양성 및 인적자본 관리',
        link: 'https://esg.sk-inc.com/?r=skinc&lv1=Materiality&lv2=%EC%98%81%ED%96%A5+%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C#order_id_12'
      },
      {
        name: '인권존중 및 보호',
        link: 'https://esg.sk-inc.com/?r=skinc&lv1=Materiality&lv2=%EC%98%81%ED%96%A5+%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C#order_id_15'
      },
      {
        name: '안전보건 관리',
        link: 'https://esg.sk-inc.com/?r=skinc&lv1=Materiality&lv2=%EC%98%81%ED%96%A5+%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C#order_id_18'
      }
    ]
  }
};

export const financialCardInfo = {
  ENG: {
    topics: [
      {
        name: 'Talent Development and Human Resource Management',
        link: 'https://esg.sk-inc.com/?l=ENG&r=skinc&lv1=Materiality&lv2=%EC%9E%AC%EB%AC%B4+%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C#order_id_6'
      },
      {
        name: 'Service Quality and Reliability',
        link: 'https://esg.sk-inc.com/?l=ENG&r=skinc&lv1=Materiality&lv2=%EC%9E%AC%EB%AC%B4+%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C#order_id_9'
      },
      {
        name: 'Climate Change Response (Mitigation/Adaptation)',
        link: 'https://esg.sk-inc.com/?l=ENG&r=skinc&lv1=Materiality&lv2=%EC%9E%AC%EB%AC%B4+%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C#order_id_12'
      },
      {
        name: 'Ethical Management and Anti-Corruption',
        link: 'https://esg.sk-inc.com/?l=ENG&r=skinc&lv1=Materiality&lv2=%EC%9E%AC%EB%AC%B4+%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C#order_id_15'
      },
      {
        name: 'Enhancing Shareholder Value',
        link: 'https://esg.sk-inc.com/?r=skinc&lv1=Materiality&lv2=%EC%9E%AC%EB%AC%B4%20%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C#order_id_18'
      }
    ]
  },
  KOR: {
    topics: [
      {
        name: '인재양성 및 인적자본 관리',
        link: 'https://esg.sk-inc.com/?r=skinc&lv1=Materiality&lv2=%EC%9E%AC%EB%AC%B4+%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C#order_id_6'
      },
      {
        name: '서비스 품질 및 안정성',
        link: 'https://esg.sk-inc.com/?r=skinc&lv1=Materiality&lv2=%EC%9E%AC%EB%AC%B4+%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C#order_id_9'
      },
      {
        name: '기후변화 대응 (완화/적응)',
        link: 'https://esg.sk-inc.com/?r=skinc&lv1=Materiality&lv2=%EC%9E%AC%EB%AC%B4+%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C#order_id_12'
      },
      {
        name: '윤리경영 및 반부패',
        link: 'https://esg.sk-inc.com/?r=skinc&lv1=Materiality&lv2=%EC%9E%AC%EB%AC%B4+%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C#order_id_15'
      },
      {
        name: '주주가치 제고',
        link: 'https://esg.sk-inc.com/?r=skinc&lv1=Materiality&lv2=%EC%9E%AC%EB%AC%B4%20%EC%A4%91%EC%9A%94%EC%A3%BC%EC%A0%9C#order_id_18'
      }
    ]
  }
};

export const esgCards = [
  {
    title: 'Environmental',
    description: `SK주식회사는 지속가능한 미래를 만들기 위해
환경의 새로운 변화를 만들어 가고 있습니다.`,
    description_e: `SK Inc. is driving environmental transformation
to shape a sustainable future.`,
    background: '/static_img/skinc/road/Contents3-2.webp',
    links: [
      {
        text: '기후변화 대응(TCFD)',
        text_e: 'Climate Change Response (TCFD)',
        url: 'https://esg.sk-inc.com/?r=skinc&lv1=Environmental&lv2=%EA%B8%B0%ED%9B%84%EB%B3%80%ED%99%94+%EB%8C%80%EC%9D%91%28TCFD%29'
      },
      {
        text: '청정기술/사업 투자',
        text_e: 'Clean Technology / Business Investment',
        url: 'https://esg.sk-inc.com/?r=skinc&lv1=Environmental&lv2=%EC%B2%AD%EC%A0%95%EA%B8%B0%EC%88%A0%2F%EC%82%AC%EC%97%85+%ED%88%AC%EC%9E%90'
      },
      {
        text: '환경영향 관리',
        text_e: 'Environmental Impact Management',
        url: 'https://esg.sk-inc.com/?r=skinc&lv1=Environmental&lv2=%ED%99%98%EA%B2%BD%EC%98%81%ED%96%A5+%EA%B4%80%EB%A6%AC'
      }
    ]
  },
  {
    title: 'Social',
    description: `SK주식회사는 구성원, 협력사, 지역사회 등
다양한 이해관계자의 행복을 추구합니다.`,
    description_e: `SK Inc. is committed to pursuing
the happiness of its diverse stakeholders,
including employees, suppliers, and local communities.`,
    background: '/static_img/skinc/road/Contents4-2.webp',
    links: [
      {
        text: '인권 경영',
        text_e: 'Human Rights Management',
        url: 'https://esg.sk-inc.com/?r=skinc&lv1=Social&lv2=%EC%9D%B8%EA%B6%8C+%EA%B2%BD%EC%98%81'
      },
      {
        text: '인재 경영',
        text_e: 'Talent Management',
        url: 'https://esg.sk-inc.com/?r=skinc&lv1=Social&lv2=%EC%9D%B8%EC%9E%AC+%EA%B2%BD%EC%98%81'
      },
      {
        text: '안전 및 보건',
        text_e: 'Safety and Health',
        url: 'https://esg.sk-inc.com/?r=skinc&lv1=Social&lv2=%EC%95%88%EC%A0%84+%EB%B0%8F+%EB%B3%B4%EA%B1%B4'
      },
      {
        text: '공급망 관리',
        text_e: 'Supply Chain Management',
        url: 'https://esg.sk-inc.com/?r=skinc&lv1=Social&lv2=%EA%B3%B5%EA%B8%89%EB%A7%9D+%EA%B4%80%EB%A6%AC'
      },
      {
        text: '정보보안',
        text_e: 'Information Security',
        url: 'https://esg.sk-inc.com/?r=skinc&lv1=Social&lv2=%EC%A0%95%EB%B3%B4%EB%B3%B4%EC%95%88'
      },
      {
        text: '서비스 품질 및 안정성',
        text_e: 'Service Quality and Reliability',
        url: 'https://esg.sk-inc.com/?r=skinc&lv1=Social&lv2=%EC%84%9C%EB%B9%84%EC%8A%A4+%ED%92%88%EC%A7%88+%EB%B0%8F+%EC%95%88%EC%A0%95%EC%84%B1'
      },
      {
        text: '사회공헌',
        text_e: 'Social Contribution',
        url: 'https://esg.sk-inc.com/?r=skinc&lv1=Social&lv2=%EC%82%AC%ED%9A%8C%EA%B3%B5%ED%97%8C'
      }
    ]
  },
  {
    title: 'Governance',
    description: `SK주식회사는 공정성과 투명성, 독립성을 기반으로 
체계적이고 지속가능한 지배구조를 구축하고 있습니다.`,
    description_e: `SK Inc. is building a systematic 
and sustainable governance structure 
with fairness, transparency, and independence at its core.`,
    background: '/static_img/skinc/road/Contents5-2.webp',
    links: [
      {
        text: '지배구조',
        text_e: 'Governance',
        url: 'https://esg.sk-inc.com/?r=skinc&lv1=Governance&lv2=%EC%A7%80%EB%B0%B0%EA%B5%AC%EC%A1%B0'
      },
      {
        text: '윤리 및 컴플라이언스',
        text_e: 'Ethics and Compliance',
        url: 'https://esg.sk-inc.com/?r=skinc&lv1=Governance&lv2=%EC%9C%A4%EB%A6%AC+%EB%B0%8F+%EC%BB%B4%ED%94%8C%EB%9D%BC%EC%9D%B4%EC%96%B8%EC%8A%A4'
      },
      {
        text: '리스크 관리',
        text_e: 'Risk Management',
        url: 'https://esg.sk-inc.com/?r=skinc&lv1=Governance&lv2=%EB%A6%AC%EC%8A%A4%ED%81%AC+%EA%B4%80%EB%A6%AC'
      }
    ]
  }
];

export const linksData = [
  {
    text: 'ESG Data',
    text_e: 'ESG Data',
    url: 'https://esg.sk-inc.com/?r=skinc&lv1=Appendix&lv2=ESG+Data',
    image: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_4002_2465)"><path d="M18.0805 1.42578H21.9438C22.1697 1.42578 22.3539 1.61704 22.3539 1.85148V17.1026C22.3539 17.337 22.1697 17.5283 21.9438 17.5283H18.0805C17.8547 17.5283 17.6704 17.337 17.6704 17.1026V1.85148C17.6704 1.61704 17.8547 1.42578 18.0805 1.42578Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/><path d="M10.0686 5.70117H13.9319C14.1577 5.70117 14.342 5.89243 14.342 6.12687V17.1086C14.342 17.3431 14.1577 17.5343 13.9319 17.5343H10.0686C9.8427 17.5343 9.65845 17.3431 9.65845 17.1086V6.12687C9.65845 5.89243 9.8427 5.70117 10.0686 5.70117Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/><path d="M5.91997 9.9707H2.05073C1.82423 9.9707 1.64062 10.1613 1.64062 10.3964V17.1088C1.64062 17.344 1.82423 17.5345 2.05073 17.5345H5.91997C6.14647 17.5345 6.33007 17.344 6.33007 17.1088V10.3964C6.33007 10.1613 6.14647 9.9707 5.91997 9.9707Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/><path d="M0.891602 22.5742H23.1085" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/></g><defs><clipPath id="clip0_4002_2465"><rect width="24" height="23" fill="white" transform="translate(0 0.5)"/></clipPath></defs></svg>`,
    description: '재무데이터 및 비재무데이터를 투명하게 공개합니다.',
    description_e: 'Financial and non-financial data are transparently disclosed.'
  },
  {
    text: 'Policy & Principle',
    text_e: 'Policy & Principle',
    url: 'https://esg.sk-inc.com/?r=skinc&lv1=Appendix&lv2=Policy+%26+Principle',
    image: `<svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_4002_2492)"><path d="M13.0034 20.7668V9.01562" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/><path d="M21.0746 8.94586C23.6168 7.49047 25.034 4.84026 25.0467 2.10743C22.6825 0.73466 19.6764 0.620262 17.1342 2.07565C14.5921 3.53104 13.1748 6.18125 13.1621 8.91408C15.5263 10.2868 18.5324 10.4012 21.0746 8.9395V8.94586Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.92575 8.94586C2.38358 7.49047 0.966324 4.84026 0.953613 2.10743C3.31783 0.73466 6.32394 0.620262 8.8661 2.07565C11.4083 3.53104 12.8255 6.18125 12.8382 8.91408C10.474 10.2868 7.46791 10.4012 4.92575 8.9395V8.94586Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.61963 5.81738L13.0666 8.71683" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/><path d="M18.3804 5.81738L12.9334 8.71683" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/></g><defs><clipPath id="clip0_4002_2492"><rect width="26" height="21.84" fill="white" transform="translate(0 0.0800781)"/></clipPath></defs></svg>`,
    description: '정책과 규범을 바탕으로 ESG 경영 체계를 확립하고 있습니다.',
    description_e:
      'An ESG management framework is being established, grounded in policies and standards.'
  },
  {
    text: '글로벌 이니셔티브',
    text_e: 'Global Initiatives',
    url: 'https://esg.sk-inc.com/?r=skinc&lv1=Appendix&lv2=%EA%B8%80%EB%A1%9C%EB%B2%8C+%EC%9D%B4%EB%8B%88%EC%85%94%ED%8B%B0%EB%B8%8C',
    image: `<svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.00136 13.0928H1.15723C1.15723 19.405 6.23439 24.52 12.4998 24.52C10.0153 24.52 8.00908 19.405 8.00908 13.0928H8.00136Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.4998 1.66602C6.23439 1.66602 1.15723 6.78107 1.15723 13.0933H8.00136C8.00136 6.78107 10.0153 1.66602 12.4921 1.66602H12.4998Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.4998 24.52C18.7652 24.52 23.8423 19.405 23.8423 13.0928H16.9982C16.9982 19.405 14.9843 24.52 12.5075 24.52H12.4998Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.4999 1.66602C14.9845 1.66602 16.9906 6.78107 16.9906 13.0933H23.8348C23.8348 6.78107 18.7576 1.66602 12.4922 1.66602H12.4999Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.00146 13.0933H16.9907C16.9907 6.78107 14.9768 1.66602 12.4999 1.66602C10.0231 1.66602 8.00918 6.78107 8.00918 13.0933H8.00146Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.9904 13.0928H8.00122C8.00122 19.405 10.0151 24.52 12.492 24.52C14.9688 24.52 16.9827 19.405 16.9827 13.0928H16.9904Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    description: '지속가능성에 부합 하는 글로벌 이니셔티브에 참여하여 책임을 다하고 있습니다.',
    description_e:
      'Efforts  are being made to fulfill responsibilities through participation in global initiatives aligned with sustainability.'
  },
  {
    text: '수상, 인증 및 협회활동',
    text_e: 'Awards, Certifications, and Association Activities',
    url: 'https://esg.sk-inc.com/?r=skinc&lv1=Appendix&lv2=%EC%88%98%EC%83%81%2C+%EC%9D%B8%EC%A6%9D+%EB%B0%8F+%ED%98%91%ED%9A%8C%ED%99%9C%EB%8F%99',
    image: `<svg width="18" height="26" viewBox="0 0 18 26" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_4002_2506)"><path d="M9.00042 25.0537C12.6396 25.0537 15.5897 22.159 15.5897 18.5884C15.5897 15.0177 12.6396 12.123 9.00042 12.123C5.36126 12.123 2.41113 15.0177 2.41113 18.5884C2.41113 22.159 5.36126 25.0537 9.00042 25.0537Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.99972 21.2697C10.5086 21.2697 11.7319 20.0695 11.7319 18.5889C11.7319 17.1084 10.5086 15.9082 8.99972 15.9082C7.4908 15.9082 6.26758 17.1084 6.26758 18.5889C6.26758 20.0695 7.4908 21.2697 8.99972 21.2697Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.7853 1.75391V7.07754C14.7853 7.8723 14.1296 8.51567 13.3196 8.51567H4.67958C3.86958 8.51567 3.21387 7.8723 3.21387 7.07754V1.75391" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M0.963867 0.946289H17.0353" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/><path d="M9 8.77344V11.3722" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_4002_2506"><rect width="18" height="26" fill="white"/></clipPath></defs></svg>`,
    description: '지속가능경영 실천을 위해 다양한 이해관계자와 협력하고 있습니다.',
    description_e:
      'Collaborative efforts are being made with diverse stakeholders to promote sustainability practices.'
  },
  {
    text: 'GRI/SASB/TCFD Index',
    text_e: 'GRI/SASB/TCFD Index',
    url: 'https://esg.sk-inc.com/?r=skinc&lv1=Appendix&lv2=GRI%2FSASB%2FTCFD+Index',
    image: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_4002_2451)"><path d="M13.708 3.10299C16.6377 6.03372 16.6377 10.7814 13.708 13.7121C10.7783 16.6428 6.03227 16.6428 3.10256 13.7121C0.172845 10.7814 0.172845 6.03372 3.10256 3.10299C6.03227 0.179213 10.7852 0.179213 13.708 3.10299Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M22.5138 19.7361C23.2841 20.5004 23.2841 21.7498 22.5138 22.514C21.7435 23.2843 20.5002 23.2843 19.7359 22.514L15.8648 18.6429C15.0945 17.8726 15.0945 16.6292 15.8648 15.859C16.6351 15.0887 17.8785 15.0887 18.6427 15.859L22.5138 19.7301V19.7361Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.1899 14.1895L15.7878 15.7873" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_4002_2451"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>`,
    description: '글로벌 기준에 따라 지속가능경영 정보를 체계적으로 공개합니다. ',
    description_e:
      'Sustainability management information is systematically disclosed in accordance with global standards.'
  },
  {
    text: 'Assurance',
    text_e: 'Assurance',
    url: 'https://esg.sk-inc.com/?r=skinc&lv1=Appendix&lv2=Assurance',
    image: `<svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.97752 19.6104V21.1743C6.97752 22.9128 5.62034 24.3217 3.90771 24.4316C3.9788 24.4316 4.04343 24.4509 4.11452 24.4509H20.2261C22.0357 24.4509 23.5027 22.9839 23.5027 21.1743V19.6104H6.97752Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.1421 19.6118V1.54199H1.49707V21.8415C1.49707 23.218 2.55696 24.3296 3.90767 24.4395" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.69434 24.4579H4.10795C4.03686 24.4579 3.97223 24.4449 3.90114 24.4385C3.83005 24.4385 3.76543 24.4579 3.69434 24.4579Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.8227 7.56391L12.4005 10.2329L9.97827 12.9018L6.61327 9.4502" stroke="currentColor" stroke-width="1.5"/></svg>`,
    description: '온실가스 배출량 및 지속가능경영 성과에 대한 독립적 검증절차를 수행하였습니다.',
    description_e:
      'Independent verification procedures have been conducted for greenhouse gas emissions and sustainability performance.'
  },
  {
    text: 'About this Report',
    text_e: 'About this Report',
    url: 'https://esg.sk-inc.com/?r=skinc&lv1=Appendix&lv2=About+this+Report',
    image: `<svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.78237 13.6749C7.13438 11.8188 7.55366 9.67181 9.03823 8.18897C10.5208 6.70413 12.6674 6.28476 14.5231 6.93287H14.5251C15.1711 8.78893 14.7538 10.9359 13.2692 12.4188C11.7847 13.9036 9.64008 14.321 7.78237 13.6749ZM7.78237 13.6749L6.81934 14.6377M7.78237 13.6749L10.0975 11.3597L10.7605 10.6968" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/><path d="M6.97752 19.6104V21.1743C6.97752 22.9128 5.62034 24.3217 3.90771 24.4316C3.9788 24.4316 4.04343 24.4509 4.11452 24.4509H20.2261C22.0357 24.4509 23.5027 22.9839 23.5027 21.1743V19.6104H6.97752Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.1421 19.6118V1.54199H1.49707V21.8415C1.49707 23.218 2.55696 24.3296 3.90767 24.4395" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_4002_2506"><rect width="25" height="26" fill="white"/></clipPath></defs></svg>`,
    description:
      'SK주식회사의 지속가능경영 성과와 주요 연결 자회사의 활동 및 성과를 포괄하여 보고합니다.',
    description_e:
      'SK Inc. reports its sustainability performance, encompassing the activities and outcomes of its major consolidated subsidiaries.'
  }
];

export const getLinks = lang => {
  if (lang === 'ENG') {
    return linksData.map(link => ({
      ...link,
      text: link.text_e || link.text,
      description: link.description_e || link.description
    }));
  }
  return linksData;
};

export const familySites = [
  {
    name: 'SK 주식회사 머티리얼즈',
    name_e: 'SK materials',
    href: 'https://www.sk-materials.co.kr',
    className: 'span-2 skinc-red-bg'
  },
  {
    name: 'SK 주식회사 C&C',
    name_e: 'SK Inc. C&C',
    href: 'https://www.skcc.co.kr',
    className: 'span-2 skinc-red-bg'
  },
  {
    name: 'SK이노베이션',
    name_e: 'SK innovation',
    href: 'https://www.skinnovation.com',
    className: ''
  },
  {
    name: 'SK텔레콤',
    name_e: 'SK telecom',
    href: 'https://www.sktelecom.com',
    className: ''
  },
  {
    name: 'SK E&S',
    name_e: 'SK E&S',
    href: 'https://www.skens.com',
    className: ''
  },
  {
    name: 'SK에코플랜트',
    name_e: 'SK ecoplant',
    href: 'https://www.skecoplant.co.kr',
    className: ''
  },
  {
    name: 'SK실트론',
    name_e: 'SK siltron',
    href: 'https://www.siltron.com',
    className: ''
  },
  {
    name: 'SK네트웍스',
    name_e: 'SK networks',
    href: 'https://www.sknetworks.co.kr',
    className: ''
  },
  { name: 'SKC', name_e: 'SKC', href: 'https://www.skc.kr', className: '' },
  {
    name: 'SK스퀘어',
    name_e: 'SK square',
    href: 'https://www.sksquare.co.kr',
    className: ''
  },
  {
    name: 'SK바이오팜',
    name_e: 'SK biopharmaceuticals',
    href: 'https://www.skbio.com',
    className: ''
  },
  {
    name: 'SK팜테코',
    name_e: 'SK pharmteco',
    href: 'https://www.skfarmteco.co.kr',
    className: ''
  },
  {
    name: 'SK리츠',
    name_e: 'SK REIT co',
    href: 'https://www.skreits.com',
    className: ''
  },
  {
    name: 'SK임업',
    name_e: 'SK forest',
    href: 'https://www.skipc.org',
    className: ''
  }
];
